import React, { useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { LayoutPreferenceContext } from "../../context/LayoutPreference/LayoutPreferenceContext";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2),
		height: `calc(100% - 48px)`,
	},
	// Fix 2026-10-22 (layout Novo, ver PROMPT.md em D:\voicechat\novo
	// layout): usuario pediu rolagem unica da pagina inteira, igual o
	// Dashboard (que nao usa este componente) - sem altura travada aqui,
	// o conteudo cresce pro tamanho natural e quem rola e' o <main> do
	// shell Novo (ja tem overflow proprio), nao mais a propria tela
	// (cada tela que usa este componente tem sua propria caixa de
	// overflowY:"auto" interna, tipo mainPaper/scrollArea - com altura
	// livre aqui elas nunca ficam mais baixas que o conteudo, entao
	// nunca criam rolagem propria, so' o <main> rola). So' muda quando
	// o layout Novo esta ativo - o Classico (sem essa condicao) continua
	// exatamente igual.
	mainContainerNewLayout: {
		flex: "0 0 auto",
		padding: theme.spacing(2),
		height: "auto",
	},
	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
	},
	contentWrapperNewLayout: {
		height: "auto",
		overflowY: "visible",
		display: "flex",
		flexDirection: "column",
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();
	const { layout } = useContext(LayoutPreferenceContext);
	const isNewLayout = layout === "new";

	return (
		<Container className={isNewLayout ? classes.mainContainerNewLayout : classes.mainContainer}>
			<div className={isNewLayout ? classes.contentWrapperNewLayout : classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
